import request from './request'
import * as http from '@/libs/http'

/**
 * ユーザに支払方法を追加する
 *
 * @param {Number} uid ユーザID
 * @param {Object} payment 支払情報
 * @returns {Response} レスポンスデータ
 */
export function newUserPayment (uid, payment) {
  return request.post(`/users/${uid}/payments`, payment, {
    validateStatus: (status) => [
      http.Created,
      http.Conflict,
      http.UnprocessableEntity,
      http.OK
    ].includes(status)
  })
}
